module.exports = __webpack_public_path__ + "static/media/pholidoptera_griseoaptera.cf710032.jpg";